module.exports = __webpack_public_path__ + "img/vertical_3_3_8003.729d9eac.png";